'use client'

import React, { useState, useRef } from 'react';
import { io, Socket } from 'socket.io-client';
import { checkMove, playerStateFromHistory, offerOrder, Action, Move, PlayerState, PlayOutcome } from '../common/logic';
import { Room, parseRooms, findRoom } from '../common/rooms';

import Game from './Game';
import GameOver from './GameOver';
import Lobby from './Lobby';
import Login from './Login';

export default function App() {
	const [username, setUsername] = useState("");
	const [socket, setSocket] = useState<Socket | null>(null);
	const [play, setPlay] = useState<PlayerState | null>(null);
	const [outcome, setOutcome] = useState<PlayOutcome | null>(null);
	const [rooms, setRooms] = useState(new Map<string, Room>());

	const playRef = useRef(play);
	React.useEffect(() => { playRef.current = play }, [play]);

	let mode: string;

	if (outcome) {
		mode = "gameover";
	} else if (play) {
		mode = "game";
	} else if (username) {
		mode = "lobby";
	} else {
		mode = "login";
	}

	function onLogin(username_: string, socket_: Socket | null): void {
		if (!socket_) {
			if (!socket)
				return;
			setOutcome(null);
			setPlay(null);
			socket!.disconnect();
			setUsername(username_);
			return;
		}
		setUsername(username_);
		setSocket(socket_);

// Ignore disconnect events -- wait for a reconnection instead
		socket_!.on("disconnect", () => {
			console.log("Disconnected.");
		});

		socket_!.on("connect", () => {
			console.log("Connection established.");
		});

		socket_!.on("error", (error) => {
			console.log("Socket error:", error);
		});

		socket_!.on("rooms", rooms => {
			console.log("Rooms changed");
			let rooms_ = parseRooms(rooms);
			console.log(rooms_);
			if (playRef.current != null) {
				console.log("Rooms changed during play");
				const room = findRoom(rooms_, username_);
				if (!room?.playing) {
					console.log("Game ended");
					console.log(room);
					setOutcome(null);
					setPlay(null);
				}
			}
			setRooms(rooms_);
		});

		socket_!.on("start", play => {
			console.log("start play: ", play);
			setOutcome(null);
			setPlay(play);
		});

		socket_!.on("history", history => {
			const moves : Move[] = history.map((move: any) => (move as Move));
			const play_ = playRef.current!;
			console.log("history: moves:", moves);
			console.log("history: play:", play_);
			setPlay(playerStateFromHistory(moves, play_));
		});

		socket_!.on("gameover", outcome => {
			setOutcome(outcome);
		});
	}

	function onChoose(room: string): void {
		socket!.emit("choose", {room: room});
	}

	function onAction(action: Action): void {
		const move = { player: username, action } as Move;
		if (!checkMove(play!, move))
			return;
		socket!.emit("move", action);
	}

	function onStart(): void {
		socket!.emit("start");
	}

	return (
		<div className="panel">
		<div className="app">
		<Login mode={mode} username={username} onLogin={onLogin} onChoose={onChoose} />
		<Game mode={mode} username={username} play={play!} onAction={onAction} />
		<GameOver mode={mode} username={username} outcome={outcome!} onRestart={onStart} />
		<Lobby mode={mode} username={username} rooms={rooms} onChoose={onChoose} onStart={onStart} />
		</div>
		</div>
	);
}

